import React, { memo } from "react";

import "./ColumnHeader.css";

interface Props {
    labelId: string;
    name: string;
    color: string;
    hasItems: boolean;
}

const ColumnHeader: React.FC<Props> = function ({ labelId, name, color, hasItems }: Props) {
    return (
        <div
            className={"column_header " + (hasItems ? "column_header--has_items" : "column_header--empty")}
            style={{ backgroundColor: color }}
        >
            <span className="column_header__label">{`${name} / ${labelId}`}</span>
        </div>
    );
}

export default memo(ColumnHeader);
